
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0g4LiV4Lix4Lin4Lit4Lix4LiB4Lip4Lij4Lir4Lij4Li34Lit4LiZ4LmJ4Lit4Lii4LiB4Lin4LmI4LiyIn0=!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0g4LiV4Lix4Lin4Lit4Lix4LiB4Lip4Lij4Lir4Lij4Li34Lit4LiZ4LmJ4Lit4Lii4LiB4Lin4LmI4LiyIn0=!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0ga2FyYWt0ZXIgYXRhdSBrdXJhbmcifQ==!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0ga2FyYWt0ZXIgYXRhdSBrdXJhbmcifQ==!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0g4LiV4Lix4Lin4Lit4Lix4LiB4Lip4Lij4Lir4Lij4Li34Lit4LiZ4LmJ4Lit4Lii4LiB4Lin4LmI4LiyIn0=!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0g4LiV4Lix4Lin4Lit4Lix4LiB4Lip4Lij4Lir4Lij4Li34Lit4LiZ4LmJ4Lit4Lii4LiB4Lin4LmI4LiyIn0=!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0ga2FyYWt0ZXIgYXRhdSBrdXJhbmcifQ==!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0ga2FyYWt0ZXIgYXRhdSBrdXJhbmcifQ==!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoie21heH0gY2hhcmFjdGVycyBvciBsZXNzIn0=!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoiW3ttYXh9IMOn4bipxIPEg8SDxZnEg8SDxIPDp+G5r+G6veG6veG6vcWZxaEgw7bDtsO2xZkgxprhur3hur3hur3FocWhXSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJNYXggY2hhcmFjdGVycyBvciBsZXNzIjoiW3ttYXh9IMOn4bipxIPEg8SDxZnEg8SDxIPDp+G5r+G6veG6veG6vcWZxaEgw7bDtsO2xZkgxprhur3hur3hur3FocWhXSJ9!"
        )
      )
      });
  
      export { translations as default };
    